import { useCallback, useEffect } from 'react';
export const createDeferHandler = (callback, timeout = 250) => {
    let timeoutId;
    const deferredCallback = (...args) => {
        const [synteticEvent] = args;
        synteticEvent?.persist?.();
        timeoutId = window.setTimeout(() => callback(...args), timeout);
    };
    deferredCallback.cancel = () => {
        clearTimeout(timeoutId);
    };
    return deferredCallback;
};
export const useDeferCallback = (callback, deps, timeout) => {
    const deferredCallback = useCallback(createDeferHandler(callback, timeout), deps);
    useEffect(() => {
        return () => {
            deferredCallback.cancel();
        };
    }, [deferredCallback]);
    return deferredCallback;
};
export const cancelDeferHandlerAfterDestroy = (store) => {
    const { getState } = store;
    return (next) => (action) => {
        if (action.type.match(/redux-form\/(CHANGE|BLUR)/) &&
            !getState().form[action.meta.form]) {
            return;
        }
        return next(action);
    };
};
